/**
 * Zero queries registry.
 *
 * All queries are defined here and exported for use in the frontend.
 * @see https://zero.rocicorp.dev/docs/queries
 */

import { defineQueries } from "@rocicorp/zero";

import { allFoods, foodById } from "./nutrition-foods";

export const queries = defineQueries({
  foods: {
    all: allFoods,
    byId: foodById,
  },
});

export type Queries = typeof queries;
